module.exports = __webpack_public_path__ + "img/home_banner_icon.de7ba7e6.png";